import { analyticsUtils } from 'utils/analytics-utils';

/**
 * Событие должно срабатывать при фокусе на инпуты размеров помещения / окон / дверей
 */

export const gaFocusOnDimensions = ({ fieldName, title }: { fieldName: string; title: string }) =>
  analyticsUtils.sendEvent('GA:focus', {
    elementType: 'focus',
    elementBlock: 'productDetail / calc',
    elementName: title, // название заголовка
    elementText: fieldName, // название поля
  });
